<template>
  <button @click="open" class="btn btn-sm btn-primary">
    <font-awesome-icon icon="plane"/>&nbsp;{{ $t('moveToNewClient') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('moveToNewClient')">
      <p><span>{{$t('userName')}}</span>: {{item.name}}</p>
      <p><span>{{$t('userEmail')}}</span>: {{item.email}}</p>
      <p><span>{{$t('currentClient')}}</span>: {{client.companyName}} ({{client.domain}})</p>
      <client-select :label="$t('newClient')" :model="formModel" attribute="newClient" :errors="formErrors"></client-select>
      <form-input :label="$t('ext')" attribute="ext" :model="formModel" :errors="formErrors"></form-input>
      <form-select :model="formModel" :errors="formErrors" :label="$t('group')" attribute="group" :options=groups :disabled="!formModel.client && getGroupsLoading"></form-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button :disabled="!formModel.newClient || !formModel.ext" class="btn btn-primary float-right" @click="move()">
          {{ $t('move') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
  import ClientSelect from "../../components/ClientSelect";
  export default {
    props: ['item', 'client'],
    components: {ClientSelect},
    data() {
      return {
        showForm: false,
        formModel: {
          newClient: null,
          ext: this.item ? this.item.ext : null,
          group: null
        },
        formErrors: [],
        groups: [{value: null, text: this.$t('default')}],
        getGroupsLoading: false
      }
    },
    methods: {
      open() {
        this.showForm = true
      },
      move() {
        let loader = this.$loading.show();
          this.$service({
          url: '/client-user/move/' + this.item._id,
          method: 'put',
          data: this.formModel
        }).then(response => {
          this.showForm = false;
          if (response.data) {
            this.$swal({
                title: this.$t('success'),
                text: this.$t('moveSuccess'),
                icon: 'success'
            });
          } else {
            this.$swal({
                title: this.$t('error'),
                text: this.$t('moveFailed'),
                icon: 'error'
            });
          }
        }).catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
            this.showForm = false;
          } else {
            this.formErrors = error.response.data;
          }
        }).finally(() => {
          this.$bus.$emit(`client${this.item.client}UserLoad`);
          this.$bus.$emit('loadClient');
          loader.hide();
        });
      },
      getGroups() {
        this.getGroupsLoading = true;
        this.groups = [{value: null, text: this.$t('default')}];
        this.$service.get('/client-user-group', {params: {page: 1, pageSize: 100, client: this.formModel.newClient}}).then(response => {
          if (response.data && response.data.docs.length) {
            response.data.docs.forEach(g => {
              this.groups.push({value: g._id, text: g.name})
            })
          }
        }).catch(error => {
          // console.log('Error getting group: ' + error);
          if (error.response.data.message) {
              this.$swal({
                  text: error.response.data.message,
                  icon: 'error'
              });
          }
        }).finally(() => {
          this.getGroupsLoading = false
        })
      }
    },
    watch: {
      "formModel.newClient": {
        handler(val) {
          if (val) {
            this.getGroups();
          } else {
            this.groups = [{value: null, text: this.$t('default')}];
          }
          this.formModel.group = null;
        }
      }
    },
    i18n: {
      messages: {
        en: {
          moveToNewClient: 'Move to new client',
          newClient: 'New client',
          move: 'Move',
          moveSuccess: 'Moved to new client!',
          moveFailed: 'Fail to move',
          default: 'Default',
          group: 'Group',
          userName: 'User name',
          userEmail: 'User email',
          currentClient: 'Current client'
        },
        vi: {
          moveToNewClient: 'Chuyển client',
          newClient: 'Client mới',
          move: 'Chuyển',
          moveSuccess: 'Chuyển client thành công!',
          moveFailed: 'Chuyển thất bại',
          default: 'Mặc định',
          group: 'Nhóm',
          userName: 'Tên người dùng',
          userEmail: 'Email',
          currentClient: 'Client hiện tại'
        }
      }
    }
  }
</script>